// DataManagementTabs is now a no-op since we removed Fields and Computed Traits tabs.
// Data Management only contains Objects, which renders directly.
// Keeping this component to avoid breaking the DataManagementPage import.

const DataManagementTabs = () => {
  return null;
};

export default DataManagementTabs;
